// 计算公式的函数，返回未知数
import {message} from "antd";

export const calDoubleIncFormula = (T1, T2, K) => {
    // 常量
    const OFFSET = 273.15;
    const known = [T1, T2, K];
    const knownCount = known.filter(v => v !== undefined).length;

    if (knownCount !== 2) {
        message.error('必须提供两个已知值').then();
        throw new Error("必须提供两个已知值");
    }

    // 计算 K
    if (T1 !== undefined && T2 !== undefined && K === undefined) {
        if (T1 === -273.15) {
            message.error('t1不应为273.15，否则导致除零错误，请重新输入').then();
            throw new Error("t1不应为273.15，否则导致除零错误，请重新输入");
        }
        if (T2 === -273.15) {
            message.error('t2不应为273.15，否则导致除零错误，请重新输入').then();
            throw new Error("t2不应为273.15，否则导致除零错误，请重新输入");
        }
        if (T1 === 20) {
            message.error('t1不应为20，否则导致除零错误，请重新输入').then();
            throw new Error("t1不应为20，否则导致除零错误，请重新输入");
        }
        const numerator = Math.pow(T2 + OFFSET, 2) - Math.pow(293.15, 2);
        const denominator = Math.pow(T1 + OFFSET, 2) - Math.pow(293.15, 2);
        const ratio = Math.pow(T2 + OFFSET, 2) / Math.pow(T1 + OFFSET, 2);
        const K = (numerator / denominator) / ratio;
        return parseFloat(K.toFixed(4));  // 保留两位小数
    }

    // 计算 T2
    if (T1 !== undefined && K !== undefined && T2 === undefined) {
        if (T1 === -273.15) {
            message.error('t1不应为273.15，否则导致除零错误，请重新输入').then();
            throw new Error("t1不应为273.15，否则导致除零错误，请重新输入");
        }
        const a = Math.pow(T1 + OFFSET, 2) - Math.pow(293.15, 2);
        const b = K / (Math.pow(T1 + OFFSET, 2) * 100);
        if ((a * b) === 1) {
            message.error('出现除零错误，请重新输入').then();
            throw new Error("出现除零错误，请重新输入");
        }
        const t2_pow2 = Math.pow(293.15, 2) / (1 - a * b)
        const t2 = Math.sqrt(t2_pow2) - OFFSET;
        return parseFloat(t2.toFixed(2));  // 保留两位小数
    }

    // 计算 T1
    if (T2 !== undefined && K !== undefined && T1 === undefined) {
        const a = Math.pow(T2 + OFFSET, 2) - Math.pow(293.15, 2);
        const b = K * Math.pow(T2 + OFFSET, 2) / 100;
        if (b === a) {
            message.error('出现除零错误，请重新输入').then();
            throw new Error("出现除零错误，请重新输入");
        }
        const t1_pow2 = (b * Math.pow(293.15, 2)) / (b - a);
        const t1 = Math.sqrt(t1_pow2) - OFFSET;

        return parseFloat(t1.toFixed(2));  // 保留两位小数
    }

    throw new Error("无法计算。请检查输入参数。");
}